import {connect} from '../../../../redux/utils'
import {getErrors, getOvertimeLevel, getUserManagementDataForUserRates, getUserRates} from './selectors'
import {addNewUserRate, deleteUserRate, rollbackLastEditedUserRateChanges, updateUserRates} from './actions'
import {bindActionCreators} from 'redux'
import {isLVTEnabled, isOVREnabled} from '../../../../features/selectors'
import {UserRatesTable} from './UserRatesTable'
import {isUserRatesReadOnly} from '../../authorizationInfo/selectors'

export class EditPanelUserRatesTable extends UserRatesTable {
    constructor({
        readOnly,
        scrollTo = () => {},
        updateUserRates = () => {},
        deleteUserRate = () => {},
        addNewUserRate = () => {},
        rollbackLastEditedUserRateChanges = () => {},
        refreshScrollCb = () => {},
        subscribeSelectorOnScroll = () => {},
    }) {
        super({
            readOnly,
            editMode: true,
            scrollTo,
            updateUserRates,
            deleteUserRate,
            addNewUserRate,
            rollbackLastEditedUserRateChanges,
            refreshScrollCb,
            subscribeSelectorOnScroll,
        })
    }
}

export default connect(
    state => ({
        userManagementData: getUserManagementDataForUserRates(state),
        userRates: getUserRates(state),
        overtimeLevel: getOvertimeLevel(state),
        ovrFeatureEnabled: isOVREnabled(state),
        lvtFeatureEnabled: isLVTEnabled(state),
        readOnly: isUserRatesReadOnly(state),
        errors: getErrors(state),
    }),
    dispatch => ({
        updateUserRates: bindActionCreators(updateUserRates, dispatch),
        deleteUserRate: bindActionCreators(deleteUserRate, dispatch),
        addNewUserRate: bindActionCreators(addNewUserRate, dispatch),
        rollbackLastEditedUserRateChanges: bindActionCreators(rollbackLastEditedUserRateChanges, dispatch),
    })
)(EditPanelUserRatesTable)


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/userRates/EditPanelUserRatesTable.js